<template>
  <div class="add-project-geodesist">
    <q-form @submit="onSubmit" class="form">
      <div class="form__item">
        <CustomSelect
          label="Тип проекта"
          :required="true"
          placeholder="Выберите тип проекта"
          :options="projectTypesOptions"
          option-value-key="project_type_id"
          option-label-key="project_type_name"
          :value="formData.project_type_id"
          @change="(val) => (formData.project_type_id = val)"
        />
      </div>
      <div class="form__item">
        <CustomSelect
          label="Группа работ"
          :required="true"
          placeholder="Выберите группу работ"
          :options="workSetCheckGroupsOptions"
          option-value-key="work_set_check_group_id"
          option-label-key="work_set_check_group_name"
          :value="formData.work_set_check_group_id"
          @change="(val) => (formData.work_set_check_group_id = val)"
        />
      </div>
      <CustomModalFooter
        :btn-loading="loading"
        submit-btn-text="Добавить"
        :disable-submit="!canSubmit"
      />
    </q-form>
  </div>
</template>

<script setup>
import { ref, reactive, computed } from "vue";
import CustomSelect from "@/components/form/CustomSelect";
import CustomModalFooter from "@/components/modal/modals/modal-footer";

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  closeModal: {
    type: Function,
    default: () => {},
  },
});

const loading = ref(false);
const formData = reactive({
  project_type_id: null,
  work_set_check_group_id: null,
});

const projectTypesOptions = computed(
  () => props.data?.projectTypesOptions ?? []
);
const workSetCheckGroupsOptions = computed(
  () => props.data?.workSetCheckGroupsOptions ?? []
);

const canSubmit = computed(
  () =>
    formData.project_type_id != null &&
    formData.work_set_check_group_id != null
);

async function onSubmit() {
  if (!canSubmit.value) return;
  loading.value = true;
  const body = {
    project_type_id: formData.project_type_id,
    work_set_check_group_id: formData.work_set_check_group_id,
  };
  await props.data?.onSubmit(body);
  loading.value = false;
}
</script>

<style scoped lang="scss">
.add-project-geodesist {
  max-width: 500px;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 15px;

  &__item {
    width: 100%;
  }
}
</style>
